import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../../node_modules/@flixbus/honeycomb/assets/scss/components/_label.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import { Injecss } from '../../../packages/injecss/injecss.js';

var bem = HoneyBem.init('label', styles);
var Label = function (_a) {
  var text = _a.text,
    labelFor = _a.labelFor,
    extraClasses = _a.extraClasses,
    requiredText = _a.requiredText,
    _b = _a.Elem,
    Elem = _b === void 0 ? 'label' : _b;
  return /*#__PURE__*/React__default__default.createElement(Elem, {
    className: bem.b(false, extraClasses),
    htmlFor: labelFor
  }, text, requiredText && " (".concat(requiredText, ")"));
};
Label.displayName = 'Label';
Label.defaultProps = {
  Elem: 'label',
  extraClasses: '',
  requiredText: null,
  labelFor: null
};
Label.propTypes = {
  text: PropTypes__default.node.isRequired,
  labelFor: function (_a) {
    var labelFor = _a.labelFor,
      Elem = _a.Elem;
    if (Elem === 'legend') {
      return null;
    }
    if (typeof labelFor !== 'string' || labelFor.trim() === '') {
      return new Error('Label component as default `label` element requires a non-empty `labelFor` prop of type string.');
    }
    return null;
  },
  requiredText: PropTypes__default.string,
  extraClasses: PropTypes__default.string,
  Elem: PropTypes__default.oneOf(['label', 'legend'])
};
var Label$1 = Injecss(Label, styles);

export { Label, Label$1 as default };
